import React, { useState } from "react";

const ZoomPage = ({ children }) => {
  const [zoomLevel, setZoomLevel] = useState(1); // Initial zoom level (1 = 100%)

  // Handler to increase zoom
  const handleZoomIn = () => {
    if (zoomLevel < 2) {
      setZoomLevel((prevZoom) => prevZoom + 0.1);
    }
  };

  // Handler to decrease zoom
  const handleZoomOut = () => {
    if (zoomLevel > 0.5) {
      setZoomLevel((prevZoom) => prevZoom - 0.1);
    }
  };

  // Apply zoom level dynamically
  const applyZoomStyle = {
    transform: `scale(${zoomLevel})`,
    transformOrigin: "top left",
    transition: "transform 0.2s ease",
  };

  return (
    <div>
      {/* Zoom Controls */}

      <div className="top-header">
        <div id="google_translate_element"></div>
        <div className="zoom-box">
          <button
            className="zoom-btn"
            onClick={handleZoomOut}
            disabled={zoomLevel <= 0.5}
          >
            -A
          </button>
          <button
            className="zoom-btn"
            onClick={handleZoomIn}
            disabled={zoomLevel >= 2}
          >
            +A
          </button>
        </div>
      </div>
      <div style={applyZoomStyle}>{children}</div>
    </div>
  );
};



export default ZoomPage;
